import { ChartsReferenceLine } from "@mui/x-charts"

import type { XReferenceLine, YReferenceLine } from "types/viewProperties.types"

interface MuiReferenceLineProps {
  xReferenceLines?: XReferenceLine[]
  yReferenceLines?: YReferenceLine[]
}

const MuiReferenceLines = ({
  xReferenceLines,
  yReferenceLines,
}: MuiReferenceLineProps) => {
  return (
    <>
      {xReferenceLines &&
        xReferenceLines.map((rl) => (
          <ChartsReferenceLine
            key={rl.x}
            x={rl.x}
            label={rl.label}
            lineStyle={rl.lineStyle}
            labelStyle={rl.labelStyle}
            labelAlign={rl.labelAlign}
          />
        ))}
      {yReferenceLines &&
        yReferenceLines.map((rl) => (
          <ChartsReferenceLine
            key={rl.y}
            y={rl.y}
            label={rl.label}
            lineStyle={rl.lineStyle}
            labelStyle={rl.labelStyle}
            labelAlign={rl.labelAlign}
          />
        ))}
    </>
  )
}

export default MuiReferenceLines
